/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SupplierInvoiceDetailsService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code) {
    const requestScreenData = {
      url: "api/SupplierInvoiceDetail",
      // top: "1",
      filter: `SupplierInvoiceCode eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },  

  async getCustomData(params) {

    const requestScreenData = {
      url: "api/" + params.url,
      filter: params.filter,
      select: params.select
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { SupplierInvoiceDetailsService };
